<section class="crisis-cards fade-in">
	<div class="crisis-content">
		<div class="info">
			<div class="headline" [translate]="'crisis-support-headline'">For Crisis Support</div>
			<div class="text" [translate]="'crisis-support-text'">If you are having an emergency, get help right away.</div>
		</div>
		<app-crisis-card [icon]="'phone'" [head]="'Call the 988 Lifeline'" [body]="'If you or a loved one are in a crisis or having suicidal thoughts, call or text 988 for 24/7 confidential support.'" [link]="'https://988lifeline.org'" [headTranslateId]="'crisis-988-head'" [bodyTranslateId]="'crisis-988-body'"></app-crisis-card>
		<app-crisis-card [icon]="'cellphone'" [head]="'Text a Crisis Counselor'" [body]="'Text HOME to 741741 to connect with a trained volunteer Crisis Counselor.'" [link]="'https://www.crisistextline.org/'" [headTranslateId]="'crisis-text-head'" [bodyTranslateId]="'crisis-text-body'"></app-crisis-card>
	</div>
</section>

<section class="crisis-cards fade-in">
	<div class="crisis-content">
		<div class="info">
			<div class="headline" [translate]="'community-support-headline'">For Community Support</div>
			<div class="text" [translate]="'community-support-text'">Access local resources for support</div>
		</div>
		<app-crisis-card *ngFor="let card of visibleCommunityCards; trackBy: trackCard" [icon]="card.icon" [head]="card.head" [body]="card.body" [link]="card.link" [headTranslateId]="card.headTranslateId" [bodyTranslateId]="card.bodyTranslateId"></app-crisis-card>
		<div class="load-more-row" *ngIf="hasMoreCommunityCards">
			<button class="load-more" (click)="loadMore()" [translate]="'community-load-more'">Load More</button>
		</div>
	</div>
</section>
